import { Outlet } from 'react-router-dom'
import React, { createContext, useEffect, useState } from "react";
import { Box, Button, Container } from "@mui/material";


const APITestingPage = () => {
  return (
      <Box sx={{
    width: "100%",
    height: "100%",      // fills the space given by its parent
    display: "flex",
    flexDirection: "column",
  }}>
            <Outlet />
      </Box>
  );
};


export default APITestingPage;